/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { forwardRef, useEffect, useState } from "react";
import DropSelect from "components-new/DropSelect";
import sass from "./tables.module.sass";
import ModalPortal from "components-new/ModalPortal";
import GroupCheck from "components-new/GroupCheck";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { Button } from "components/shared";
import { useParams } from "react-router-dom";
import { ReactComponent as LoadIcon } from "images/load.svg";
import cn from "classnames";
import { snackWrapper } from "helpers";
import { organizationAPI } from "libs/apiClient/Organization";
import { ActualThreatResponse } from "libs/apiClient/data-contracts";

interface IDropDownMenu {
	toggle: boolean;
	target: any;
	close: () => void;
	table?: boolean;
	setActual: (e: ActualThreatResponse[]) => void;
	thread: any;
	confirm: boolean;
	openConfirm: () => void;
	categoryExist?: boolean;
	checkTables: (modal: { type: "pattern" | "model"; ok: (() => void) | null }) => void;
	applyPattern: () => void;
}

/**
 * компонент выпадающего списка с полями для загрузки и выгрузки документов
 */
const DropDownMenu = forwardRef<any, IDropDownMenu>(
	(
		{
			categoryExist = false,
			confirm: confirmModal,
			openConfirm,
			table = true,
			thread,
			setActual,
			toggle,
			close,
			target,
			checkTables,
			applyPattern,
		},
		ref,
	) => {
		const [modal, setModal] = useState(false);

		const [detail, setDetail] = useState(true);

		const [confirm, setConfirm] = useState(true);

		const params = useParams();

		const [load, setLoad] = useState(false);

		useEffect(() => {
			if (table !== undefined) {
				setConfirm(table);
			}
		}, [table]);

		const selectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
			if (e.target.files && e.target.files.length) {
				send(e.target.files[0]);
				// setFile(file)
				setModal(true);
			} else {
				close();
			}
		};

		const send = (file: File) => {
			setLoad(true);
			organizationAPI
				.objectDocumentsCreate(
					+params.threadId!,
					{
						detail,
					},
					{ file },
				)
				.then((r) => {
					setModal(false);
					setConfirm(true);
					setLoad(false);
					close();
					setActual(r.data);
					snackWrapper("success", "Файл успешно загружен!");
				})
				.catch(() => {
					setLoad(false);
					setConfirm(false);
					setActual([]);
					close();
				});
		};

		const closeModal = () => {
			setModal(false);
			close();
		};

		const testClick = () => {
			new Promise(async () => {
				let file = await organizationAPI.objectThreatDetail(+params.threadId!).then((r) => r.data.doc);
				if (await file) {
					organizationAPI.objectDocumentDetail(+params.threadId!, { format: "blob" }).then((response) => {
						const href = URL.createObjectURL(response.data);
						const link = document.createElement("a");
						link.href = href;
						link.setAttribute("download", thread?.doc || "threats");
						document.body.appendChild(link);
						link.click();
						URL.revokeObjectURL(href);
					});
					// $api({
					// 	url: `/organization/object/${}/document`,
					// 	method: "GET",
					// 	responseType: "blob",
					// }).then((response) => {
					// 	const href = URL.createObjectURL(response.data);
					// 	const link = document.createElement("a");
					// 	link.href = href;
					// 	link.setAttribute("download", thread?.doc || "threats");
					// 	document.body.appendChild(link);
					// 	link.click();
					// 	URL.revokeObjectURL(href);
					// });
				} else {
					snackWrapper("warn", "Вы еще не импортировали файл ФСТЭК");
				}
			});
		};

		const downloadVerifyDoc = () => {
			checkTables({
				type: "model",
				ok: () => {
					organizationAPI
						.objectDocumentVerifyDetail(+params.threadId!, { format: "blob" })
						.then((response) => {
							let fileName: string;
							if (response.headers["content-disposition"]) {
								fileName = decodeURI(response.headers["content-disposition"]).replace(/.+filename=(.+)\..+$/g, "$1");
							}
							const href = URL.createObjectURL(response.data);
							const link = document.createElement("a");

							link.href = href;
							link.setAttribute("download", fileName! || "verify");
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							URL.revokeObjectURL(href);
						})
						.catch((error) => {
							if (error.response && error.response.status === 403) {
								snackWrapper("warn", "Скачивание документа недоступно, так как заполнена не вся информация");
							}
						});
				},
			});
		};

		return toggle ? (
			<DropSelect zIndex={5} target={target.current} widthTarget={false}>
				<div ref={ref} className={sass.dropdownDots}>
					{modal && (
						<ModalPortal
							handleClose={closeModal}
							title={confirm ? "Загрузить новый файл?" : "Какие данные об угрозах использовать?"}
							subtitle={
								confirm && "При повторной загрузке документа предыдущие данные будут удалены. Загрузить новый документ?"
							}>
							{!load ? (
								confirm ? (
									<div className={sass.loadFile}>
										<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={closeModal}>
											Отмена
										</Button>
										<Button variant={BUTTON_VARIANTS.CONTAINED} onClick={() => setConfirm(false)}>
											Загрузить
										</Button>
									</div>
								) : (
									<div className={sass.loadFileWrapper}>
										<GroupCheck.Wrapper label={"Выбор данных"} required={true}>
											<GroupCheck.Item
												name={"detail"}
												onChange={() => setDetail(true)}
												value={"1"}
												checked={detail}
												label={"Использовать детальные данные"}
												type={"radio"}
											/>
											<GroupCheck.Item
												name={"detail"}
												onChange={() => setDetail(false)}
												value={"0"}
												checked={!detail}
												label={"Использовать обобщенные данные"}
												type={"radio"}
											/>
										</GroupCheck.Wrapper>
										<div className={sass.loadFile}>
											<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={closeModal}>
												Отмена
											</Button>
											{/*<Button variant={BUTTON_VARIANTS.CONTAINED} onClick={()=>send(file)}>Готово</Button>*/}

											<label className={cn(sass.calc_link)}>
												<input
													accept={
														".csv,application/vnd.ms-excel,.xlt,application/vnd.ms-excel,.xla,application/vnd.ms-excel,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xltx,application/vnd.openxmlformats-officedocument.spreadsheetml.template,.xlsm,application/vnd.ms-excel.sheet.macroEnabled.12,.xltm,application/vnd.ms-excel.template.macroEnabled.12,.xlam,application/vnd.ms-excel.addin.macroEnabled.12,.xlsb,application/vnd.ms-excel.sheet.binary.macroEnabled.12"
													}
													onAbort={close}
													onChange={selectFile}
													id={"file"}
													type={"file"}
													hidden={true}
												/>
												<Button variant={BUTTON_VARIANTS.CONTAINED}>Готово</Button>
											</label>
										</div>
									</div>
								)
							) : (
								<div className={sass.loading}>
									<LoadIcon />
								</div>
							)}
						</ModalPortal>
					)}
					<div
						className={sass.item}
						onClick={() => {
							// if (categoryExist) {
							//     Snackbar({
							//         type:'warn',
							//         position:'top-center',
							//         title:'Категория уже присвоена, редактирование невозможно',
							//         delay:3000,
							//         factor:'light'
							//     })
							//     return
							// }
							confirmModal ? openConfirm() : setModal(true);
						}}>
						{/*<UploadIcon />*/}
						<div className={cn(sass.dropIcon, sass.fstek)} />
						Импорт файла ФСТЭК
					</div>
					<div className={sass.item} onClick={testClick}>
						<div className={cn(sass.dropIcon, sass.eye)} />
						{/*<EyeIcon />*/}
						Просмотреть документ ФСТЭК
					</div>
					<div className={sass.item} onClick={downloadVerifyDoc}>
						<div className={cn(sass.dropIcon, sass.download)} />
						{/*<DownLoadIcon />*/}
						Скачать документ МУ для утверждения
					</div>
					{/*<div className={sass.item} onClick={applyPattern}>*/}
					{/*	<div className={cn(sass.dropIcon, sass.pattern)} />*/}
					{/*	Применить шаблон*/}
					{/*</div>*/}
				</div>
			</DropSelect>
		) : null;
	},
);

export default DropDownMenu;
